// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Note-module_subtitle_1Gwt4","tableNote":"Note-module_tableNote_1g4B8","user":"Note-module_user_hz-wN","detail":"Note-module_detail_389Zm"};